//
// Object.fromEntries
//

export const typeSafeObjectFromEntries = <const T extends readonly (readonly [PropertyKey, unknown])[]>(
    entries: T
): { [K in T[number] as K[0]]: K[1] } => Object.fromEntries(entries) as { [K in T[number] as K[0]]: K[1] };

//
// Object.entries
// (add const param for less broader types (ie. string -> "apple") -> const T extends Record<PropertyKey, unknown>)
//

export const typeSafeObjectEntries = <T extends Record<PropertyKey, unknown>>(
    obj: T
): { [K in keyof T]: [K, T[K]] }[keyof T][] => Object.entries(obj) as { [K in keyof T]: [K, T[K]] }[keyof T][];

export const typeSafeObjectKeys = <T extends Record<PropertyKey, unknown>>(obj: T) => Object.keys(obj) as (keyof T)[];
